export const Vencimientos = {
  'null': '',
  '0': 'En Plazo',
  '-1': 'Extendido',
  '-2': 'Vencido',
  '0 horas, 0 minutos': 'En Plazo',
  'slanoinit': 'SLA no ha iniciado'
};
